import { render, staticRenderFns } from "./CustomPopoverV2.vue?vue&type=template&id=618b5fb2"
import script from "./CustomPopoverV2.vue?vue&type=script&lang=js"
export * from "./CustomPopoverV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports